// import the react components
import React, {useState} from "react";

// import the custome components
import Modal from "./../modal";

// import the styles
import {input_style} from "./../../assets/data/style";

// import the api components
import axios from "axios";
import {REQUEST_API} from "./../../assets/data/api";

// import the context
import {useStateContext} from "./../../context/";

// import the workers category
import {workers_category} from "./../../assets/data/workers";

// the worker modal functional based component
const WorkerModal = () => {
    const {set_worker_modal, is_loged, set_alert} = useStateContext();
    const [state, set_state] = useState({
        type: workers_category[0],
        description: "",
    });

    // close the modal
    const handle_close = () => {
        set_worker_modal(false);
    };

    // handle the create and update
    const handle_submit = () => {

        // prepare the query
        const endpoint = REQUEST_API + "create.php";
        const data = {
            ...state,
            username: is_loged.username,
            request: "worker",
        };

        // send the query to the server
        axios.post(endpoint, data).then(response => {
            const {data} = response;
            if (data.success){
                set_alert({type: "success", text: "the request saved successfuly"});
                handle_close();
            }

            // if the error occured
            else if (data.error) set_alert({type: "error", text: data.error});
        })
    };

    // the footer buttons
    const buttons = [
        {
            title: "save",
            handler: handle_submit,
        },
    ];

    // extract the data
    const {type, description} = state;

    // return to the component data
    return (
        <Modal handle_close={handle_close} buttons={buttons} z_index={10}>
            <div className="grid grid-cols-1 gap-y-4">
                <select value={type} onChange={event => set_state({...state, type: event.target.value})} className={`${input_style}`}>
                    {workers_category.map(item => <option key={item} value={item}>{item}</option>)}
                </select>

                <input
                    type="text"
                    name="description"
                    placeholder="set the description"
                    value={description}
                    onChange={event => set_state({...state, description: event.target.value})} 
                    className={`${input_style}`}
                    required
                />
            </div>
        </Modal>
    );
};
export default WorkerModal;